var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn-primary",style:(_vm.radius ? ("border-radius:" + _vm.radius + "px;") : ''),attrs:{"type":_vm.type},on:{"click":_vm.btnClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }